import { Link } from "react-router-dom";

const JobFeedbackRightPanel = ({ cqResponseData = {} }) => {
  return (
    <div className="right_survey right_cv_info bg-white px-3 py-4">
      <div className="overlay"></div>
      <div className="cv_review text-right bg-white p-3 mb-3">
        <Link
          className="d-inline-flex align-items-center gap-2 text-black fs-lg fw-semibold"
          to="#"
          data-bs-toggle="offcanvas"
          data-bs-target="#review_canvas"
        >
          <i className="material-symbols-outlined fs-xl">filter_list</i>
          <span>Show Review</span>
        </Link>
      </div>

      <div className="other_projects body-bg p-4 rounded-10 mb-4">
        <div className="project_refence">
          <h5 className="text-black fw-semibold mb-4">Executive Summary </h5>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Startup Name:</strong> <span className="text-danger">*</span> {cqResponseData.startupname || "Not provided"}</p>
                <p><strong>Website:</strong> {cqResponseData.startupwebsite || "N/A"}</p>
                <p><strong>Email:</strong> {cqResponseData.startupemail || "N/A"}</p>
                <p><strong>Tagline:</strong> {cqResponseData.startuptagline || "N/A"}</p>
              </div>
              <div className="col-md-6">
              <p><strong>Description:</strong> <span className="text-danger">*</span> {cqResponseData.startupdescription ? cqResponseData.startupdescription.substring(0, 100) + '...' : "Not provided"}</p>
                <p><strong>Problem Statement:</strong> <span className="text-danger">*</span> {cqResponseData.problemstatement ? cqResponseData.problemstatement.substring(0, 100) + '...' : "Not provided"}</p>
                <p><strong>Solution:</strong> <span className="text-danger">*</span> {cqResponseData.solution ? cqResponseData.solution.substring(0, 100) + '...' : "Not provided"}</p>
              </div>
            </div>
          </div>
         
        </div>
      </div>

      <div className="other_projects body-bg p-4 rounded-10 mb-4">
        <div className="project_refence">
          <h5 className="text-black fw-semibold mb-4">Product/Service </h5>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Description:</strong> <span className="text-danger">*</span> {cqResponseData.productdescription ? cqResponseData.productdescription.substring(0, 100) + '...' : "Not provided"}</p>
                <p><strong>Development Stage:</strong> {cqResponseData.currentdevelopmentstage || "N/A"}</p>
                <p><strong>Roadmap:</strong> {cqResponseData.productdevelopmentroadmap ? cqResponseData.productdevelopmentroadmap : "N/A"}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Technology:</strong> {cqResponseData.technology || "N/A"}</p>
                <p><strong>Intellectual Property:</strong> {cqResponseData.intellectualproperty || "N/A"}</p>
                <p><strong>Competitive Advantage:</strong> {cqResponseData.productcompetitiveadvantage || "N/A"}</p>
              </div>
            </div>
          </div>
         
        </div>
      </div>

      <div className="skil_table_innr rounded-10 body-bg p-4 overflow-hidden">
        <div className="scroll_table_innr">
          <h5 className="text-black fw-semibold mb-3">Market Analysis </h5>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Market Size:</strong> {cqResponseData.marketsize || "N/A"}</p>
                <p><strong>Market Trends:</strong> {cqResponseData.markettrends || "N/A"}</p>
                <p><strong>Target Market:</strong> {cqResponseData.targetmarket || "N/A"}</p>
                <p><strong>Competitors:</strong> {cqResponseData.competitors || "N/A"}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Competitive Advantage:</strong> {cqResponseData.competitiveadvantage || "N/A"}</p>
                <p><strong>Entry Barriers:</strong> {cqResponseData.entrybarriers || "N/A"}</p>
                <p><strong>Differentiation:</strong> {cqResponseData.differentiationstrategy || "N/A"}</p>
                <p><strong>Customer Acquisition:</strong> {cqResponseData.customeracquisitionstrategy || "N/A"}</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div className="skil_table_innr rounded-10 body-bg p-4 overflow-hidden">
        <div className="scroll_table_innr">
          <h5 className="text-black fw-semibold mb-3">Funding Request </h5>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Funding Amount:</strong> <span className="text-danger">*</span> {cqResponseData.fundingamount || "Not provided"}</p>
                <p><strong>Proposed Value:</strong> {cqResponseData.proposedvalue || "N/A"}</p>
                <p><strong>Funding Use:</strong> {cqResponseData.fundinguse || "N/A"}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Expected Runway:</strong> {cqResponseData.expectedrunway || "N/A"}</p>
                <p><strong>Milestones:</strong> {cqResponseData.milestones || "N/A"}</p>
                {cqResponseData.previousfunding?.length > 0 && (
                  <div>
                    <p><strong>Previous Funding:</strong></p>
                    <ul className="list-unstyled ms-3">
                      {cqResponseData.previousfunding.slice(0, 2).map((funding, index) => (
                        <li key={index}>• {new Date(funding.date).toLocaleDateString()} - {funding.company} (${funding.amount})</li>
                      ))}
                      {cqResponseData.previousfunding.length > 2 && <li>• ... and {cqResponseData.previousfunding.length - 2} more</li>}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          
        </div>
      </div>


      <div className="skil_table_innr rounded-10 body-bg p-4 overflow-hidden">
        <div className="scroll_table_innr">
          <h5 className="text-black fw-semibold mb-3">Business Model </h5>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Revenue Sources:</strong> {cqResponseData.revenuesources || "N/A"}</p>
                <p><strong>Distribution Channels:</strong> {cqResponseData.distrubutionchannels || "N/A"}</p>
                <p><strong>Gross Margin:</strong> {cqResponseData.grossmargin || "N/A"}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Scalability Plan:</strong> {cqResponseData.scalabilityplan || "N/A"}</p>
                <p><strong>Real-time Order Tracking:</strong> {cqResponseData.realtimeordertracking ? "Yes" : "No"}</p>
                
                {cqResponseData.pricingstrategy?.length > 0 && (
                  <div>
                    <p><strong>Pricing Strategy:</strong></p>
                    <ul className="list-unstyled ms-3">
                      {cqResponseData.pricingstrategy.slice(0, 2).map((strategy, index) => (
                        <li key={index}>• {strategy.duration} - {strategy.name} (${strategy.price})</li>
                      ))}
                      {cqResponseData.pricingstrategy.length > 2 && 
                        <li>• ... and {cqResponseData.pricingstrategy.length - 2} more</li>}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          
        </div>
      </div>



      


    </div>
  );
};

export default JobFeedbackRightPanel;
